import { render, staticRenderFns } from "./SocietyRegistration.vue?vue&type=template&id=5a072fde&scoped=true"
import script from "./SocietyRegistration.vue?vue&type=script&lang=js"
export * from "./SocietyRegistration.vue?vue&type=script&lang=js"
import style0 from "./SocietyRegistration.vue?vue&type=style&index=0&id=5a072fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a072fde",
  null
  
)

export default component.exports